import styled, { css, createGlobalStyle } from 'styled-components';

const MODAL_CARD_SELECTOR = '#gator-protect-automatic-cleaning-consent-modal-card';
export const ModalCardOverride = createGlobalStyle`
  ${({ theme }) => css`
    ${MODAL_CARD_SELECTOR} {
      border-radius: 24px !important;
      max-width: 600px !important;
      overflow: hidden !important;
    }

    ${MODAL_CARD_SELECTOR} > div:last-child {
      overflow-y: hidden !important;
    }

    ${MODAL_CARD_SELECTOR} #close-button {
      position: relative;
    }

    ${MODAL_CARD_SELECTOR} #close-button button {
      left: auto;
      position: absolute;
      right: 24px;
      top: 24px;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      ${MODAL_CARD_SELECTOR} {
        border-radius: 0 !important;
        max-height: 100vh !important;
        max-width: 100% !important;
      }

      ${MODAL_CARD_SELECTOR} > div:last-child {
        overflow-y: auto !important;
      }

      ${MODAL_CARD_SELECTOR} #close-button button {
        right: 16px;
        top: 16px;
      }
    }
  `}
`;

export const Container = styled.div`
  ${({ theme }) => css`
    background: ${theme.v3.colors.neutral[100]};
    border-radius: 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    font-family: ${theme.v3.font.family.brand};
    margin: 0 auto;
    padding: 24px;
    width: 600px;
    max-width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 24px;
      width: 100%;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      border-radius: 0;
      min-height: 100vh;
      padding: 56px 16px 24px;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes.large};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
    padding-right: 56px;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      font-size: ${theme.v3.font.sizes['1xmedium']};
      padding-right: 44px;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 24px 0 0;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      margin-top: 24px;
    }
  `}
`;

export const CheckboxLabel = styled.div`
  ${({ theme }) => css`
    align-items: center;
    color: inherit;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    gap: 4px;
    margin: 24px 0 0;
    text-align: left;

    button {
      padding: 4px;
    }

    label {
      border-radius: 4px;
      height: 16px;
      width: 16px;
    }

    input:checked ~ label {
      border-radius: 4px;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      margin-top: 24px;
    }
  `}
`;

export const CheckboxText = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    gap: 16px;
    justify-content: center;
    margin-top: 16px;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      flex-direction: column-reverse;
      gap: 16px;
      margin-top: 16px;

      > button {
        width: 100%;
      }
    }
  `}
`;
